<div class="row search-generic-container">
  <div class="col-2 d-none d-md-block">
    <div class="img-loader"></div>
  </div>
  <div class="col col-md-10 col-right px-0 px-md-3">
    <div class="col-4 line-loader title mb-4 mb-md-3"></div>
    <div class="col-12 line-loader mb-3" *ngFor="let i of [0, 1]"></div>
    <div class="col-10 col-md-8 line-loader mt-3 mt-md-0"></div>
  </div>
</div>
